export enum DiscountType {
  Dollar,
  Percentage,
}
